import { useState } from "react";
import { APIHandlerPerformanceGolf } from "hooks/api-handler-performance-golf";

export function UseLazyApiCallPerformanceGolf({
  url,
  method,
  paramsData,
}: any) {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>();

  async function getData(props: any) {
    const localData = props?.params || paramsData;
    const localUrl = props?.url || url;

    let apiResponseInitial = null;

    try {
      setIsLoading(true);
      const data: any = await APIHandlerPerformanceGolf({
        method,
        url: localUrl,
        data: localData,
      });

      setData(data);
      apiResponseInitial = data;
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
    return apiResponseInitial;
  }

  return [getData, { data, isLoading, error }];
}
